import { jsxs, jsx } from "react/jsx-runtime";
import { Button, Icon, Typography } from "@perxis-auto/ui-kit";
import clsx from "clsx";
import styles from "./BottomNav.module.scss.js";
const BottomNav = ({
  onPrevClick,
  onNextClick,
  children,
  className,
  isHidden = false,
  ...props
}) => {
  return /* @__PURE__ */ jsxs("nav", { className: clsx(styles.bottomNav, { [styles["bottomNav--hidden"]]: isHidden }, className), ...props, children: [
    /* @__PURE__ */ jsx(
      Button,
      {
        type: "text",
        "aria-label": "left navigation",
        onClick: onPrevClick,
        icon: /* @__PURE__ */ jsx(Icon, { name: "left", size: 18, sticker: "comparison-list-bottom-nav-icon" }),
        className: styles.bottomNav__button
      }
    ),
    /* @__PURE__ */ jsx(Typography.Text, { color: "darkest", level: "super-small", children }),
    /* @__PURE__ */ jsx(
      Button,
      {
        type: "text",
        "aria-label": "right navigation",
        onClick: onNextClick,
        icon: /* @__PURE__ */ jsx(Icon, { name: "right", size: 18, sticker: "comparison-list-bottom-nav-icon" }),
        className: styles.bottomNav__button
      }
    )
  ] });
};
export {
  BottomNav
};
